import type { StreamingEvent } from '../../types/chat.types';
import type {
  ContentProcessorState,
  ImageNode,
} from '../contentProcessor.types';

import { createErrorDirective } from '../../utils/directives';
import { parseErrorMessage } from '../../utils/errorsHelper';
import { appendTextNode } from '../nodes';

export function handleImageEvent(
  state: ContentProcessorState,
  event: StreamingEvent<'image'>,
): ContentProcessorState {
  // If we have base64 data, create an image node
  if (event.data.base64_data && event.data.format) {
    const base64Src = `data:image/${event.data.format};base64,${event.data.base64_data}`;
    const imageNode: ImageNode = {
      type: 'image',
      src: base64Src,
      alt:
        [event.data.filename, event.data.alt_text].find(
          (value): value is string => value !== undefined && value !== '',
        ) ?? 'Image',
      base64_data: event.data.base64_data,
      format: event.data.format,
      filename: event.data.filename ?? '',
      circuit_id: event.data.circuit_id ?? '',
      document_id: event.data.document_id ?? '',
    };

    return {
      ...state,
      nodes: [...state.nodes, imageNode],
      chunks: {
        ...state.chunks,
        progress: [],
        image: [...state.chunks.image, event.data],
      },
    };
  }

  const errorMessage = parseErrorMessage(
    'Image data is incomplete or missing.',
    'An error occurred',
    state.options.isDebugMode,
  );
  const errorMarkdown = createErrorDirective(errorMessage);

  return {
    ...state,
    nodes: appendTextNode(state.nodes, errorMarkdown),
    chunks: {
      ...state.chunks,
      progress: [],
      image: [...state.chunks.image, event.data],
    },
  };
}
